import React, { useEffect, useMemo, useState } from "react";
import { Button, Select } from "antd";
import TextStyles from "../../../../../../components/Elements/TextStyles/TextStyles";
import CardsBorder from "../../../../../../components/Cards/CardsBorder";
import CustomSwitch from "../../../../../../components/Elements/CustomSwitch/CustomSwitch";
import { ReactComponent as DateIcon } from "../../../../../../assets/svgs/date.svg";

const { Option } = Select;

const formatPercent = (current, used) => {
  if (!current) return "0%";
  const value = Math.round((used / current) * 100);
  return `${Number.isFinite(value) ? value : 0}%`;
};

const ProjectLevel = ({ projects = [] }) => {
  const [selectedProjectId, setSelectedProjectId] = useState("");

  const [formSettings, setFormSettings] = useState([
    {
      title: "Use of Dynamic Form in the Project",
      description:
        "When Enabled, Customer Can Use Any Form From The OffsetGo Library.",
      date: "2026-08-01",
      enabled: true,
    },
    {
      title: "Allow The Section-Level Form Assignment",
      description:
        "When Enabled, Customer Can Create Custom Forms Using Pre-Approved Questions.",
      date: "2026-08-01",
      enabled: false,
    },
  ]);

  useEffect(() => {
    if (!selectedProjectId && projects.length > 0) {
      setSelectedProjectId(projects[0]._id);
    }
  }, [projects, selectedProjectId]);

  const selectedProject = useMemo(
    () =>
      projects.find((project) => project._id === selectedProjectId) ||
      projects[0],
    [projects, selectedProjectId],
  );

  const licenseRows = useMemo(() => {
    const license = selectedProject?.license || {};
    const rows = [
      // {
      //   licenseType: "Sub Admin",
      //   current: license.sub_admin?.total ?? 0,
      //   used: license.sub_admin?.used ?? 0,
      //   available: license.sub_admin?.unused ?? 0,
      // },
      {
        licenseType: "User",
        current: license.user?.total ?? 0,
        used: license.user?.used ?? 0,
        available: license.user?.unused ?? 0,
      },
      {
        licenseType: "Employee",
        current: license.employee?.total ?? 0,
        used: license.employee?.used ?? 0,
        available: license.employee?.unused ?? 0,
      },
      {
        licenseType: "Vendor",
        current: license.vendor?.total ?? 0,
        used: license.vendor?.used ?? 0,
        available: license.vendor?.unused ?? 0,
      },
      {
        licenseType: "Local Supervisor",
        current: license.local_supervisor?.total ?? 0,
        used: license.local_supervisor?.used ?? 0,
        available: license.local_supervisor?.unused ?? 0,
      },
    ];

    return rows.map((row) => ({
      ...row,
      usage: formatPercent(row.current, row.used),
      date: "2026-08-01",
      newAmount: 0,
    }));
  }, [selectedProject]);

  const customerLevelLicenseHeader = [
    { key: "licenseType", label: "LICENSE TYPE" },
    { key: "current", label: "CURRENT" },
    { key: "used", label: "USED" },
    { key: "available", label: "AVAILABLE" },
    { key: "usage", label: "USAGE" },
    // { key: "date", label: "DATE" },
    // { key: "newAmount", label: "NEW AMOUNT" },
  ];

  return (
    <div className="mx-4">
      <TextStyles style={{ fontSize: "20px", fontWeight: 500 }}>
        <p className="mt-10 text-[#06513D]">PROJECT LEVEL LICENSE & FEATURES</p>
      </TextStyles>

      <p className="font-light mt-[-10px]">
        Select a project to manage its licences and enable/disable features
      </p>

      <TextStyles
        className="text-[#06513D]"
        style={{ fontSize: "20px", fontWeight: 500 }}
      >
        <p className="mt-10">SELECT PROJECT</p>
      </TextStyles>

      <Select
        value={selectedProjectId || undefined}
        onChange={(value) => setSelectedProjectId(value)}
        placeholder="Select Project"
        className="w-full mt-2"
        size="large"
        bordered
        style={{
          border: "1px solid #06513D",
          borderRadius: "0.5rem",
          color: "#06513D",
          fontSize: "1.125rem",
          fontWeight: 500,
        }}
        dropdownStyle={{ color: "#06513D", fontWeight: 500 }}
        listHeight={256}
        popupMatchSelectWidth
      >
        {projects.map((project) => (
          <Option key={project._id} value={project._id}>
            {project.name}
          </Option>
        ))}
      </Select>

      {selectedProject && (
        <div className="w-full bg-[#E6EEEC] text-[#1F2A37] rounded-lg my-4">
          <div className="py-8 px-6">
            <p className="font-semibold">{selectedProject.name}</p>

            <div className="flex gap-6 font-light text-[13px] flex-wrap">
              <div className="flex gap-2">
                <div className="pt-[2px]">
                  <DateIcon />
                </div>
                Project ID : {selectedProject._id}
              </div>
              <div className="flex gap-2">
                <div className="pt-[2px]">
                  <DateIcon />
                </div>
                Status : {selectedProject.isActive ? "Active" : "Inactive"}
              </div>
            </div>
          </div>
        </div>
      )}

      <CardsBorder>
        <div className="rounded-md">
          <table className="w-full text-left">
            <thead className="bg-[#E6EEEC] text-sm font-semibold text-[#1F2A37]">
              <tr>
                {customerLevelLicenseHeader.map((header) => (
                  <th key={header.key} className="px-2 py-2">
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-sm text-black px-4">
              {licenseRows.map((row, index) => (
                <tr key={index} className="border-b border-gray-300">
                  <td className="px-2 py-3">{row.licenseType}</td>
                  <td className="px-2">{row.current}</td>
                  <td className="px-2">{row.used}</td>
                  <td className="px-2">{row.available}</td>
                  <td className="px-2">
                    <div className="w-full bg-gray-200 rounded h-2">
                      <div
                        className="bg-[#06513D] h-2 rounded"
                        style={{ width: row.usage }}
                      />
                    </div>
                    <span className="text-xs">{row.usage}</span>
                  </td>
                  {/* <td className="px-2">
                    <input
                      type="date"
                      value={row.date}
                      readOnly
                      className="border border-black rounded px-2 py-1 w-[130px]"
                    />
                  </td> */}
                  {/* <td className="px-2">
                    <input
                      type="number"
                      min="1"
                      value={row.newAmount === 0 ? "" : row.newAmount}
                      readOnly
                      placeholder="0"
                      className="border border-black rounded px-2 py-1 w-[60px]"
                    />
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardsBorder>

      {/* <TextStyles
        style={{
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        <p className="mx-4 mt-10 text-[#06513D]"> PROJECT FEATURES</p>
      </TextStyles>

      <div className="">
        <CardsBorder>
          {formSettings.map((setting, index) => (
            <div key={index}>
              <div className="flex justify-between mx-10">
                <div>
                  <p className="text-lg font-[300]">{setting.title}</p>
                  <p className="mt-[-10px] text-[13px] text-[#808080] font-[400] ">
                    {setting.description}
                  </p>
                </div>
                <div className="flex justify-around gap-20 items-center">
                  <input
                    type="date"
                    value={setting.date}
                    onChange={(e) => {
                      const updated = [...formSettings];
                      updated[index].date = e.target.value;
                      setFormSettings(updated);
                    }}
                    className="border border-black rounded px-2 py-1 w-[120px] text-right"
                  />
                  <CustomSwitch
                    checked={setting.enabled}
                    onChange={(val) => {
                      const updated = [...formSettings];
                      updated[index].enabled = val;
                      setFormSettings(updated);
                    }}
                  />
                </div>
              </div>

              <div className="pb-3 px-4">
                <hr />
              </div>
            </div>
          ))}

          <div className="text-center py-5">
            <Button
              type="primary"
              style={{ background: "#06513D" }}
              className="text-sm font-bold px-6 py-5"
            >
              Save Change
            </Button>
          </div>
        </CardsBorder>
      </div> */}
    </div>
  );
};

export default ProjectLevel;
